module.exports = __webpack_public_path__ + "1792395595471/fonts/Metropolis-Bold.87cfcb6.woff2";